import { Component, OnInit, Renderer2 } from '@angular/core';
import {TrackingService} from '../../services/tracking.service';
import {ViewTextesLegauxComponent} from '../../modules/textes-legaux/view-textes-legaux/view-textes-legaux.component';
import {MatDialog} from '@angular/material';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {LoaderService} from '../../services/loader.service';
import {
    OapStandarErrorStateMatcher,
    SupportErrorMessages
} from '../../modules/custom-validators/custom-validators.module';
import {first} from 'rxjs/operators';
import {PatientService} from '../../services/patient.service';
import {Support} from '../../models/Support';
import {AlertService} from '../../services/alert.service';
import {Router} from '@angular/router';

@Component({
  selector: 'oap-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit {
  public hideContent: boolean;
  public animCurrentlyPlaying: boolean;
    supportForm: FormGroup;
    submitted = false;
    validation_support = SupportErrorMessages;
    matcher = new OapStandarErrorStateMatcher();
    submitLoading = false;
    patientId: number;
    subjectsList: any;
    alertMessageSendedShowed = false;

  constructor(
      private renderer: Renderer2,
      private dialog: MatDialog,
      private loaderService: LoaderService,
      private formBuilder: FormBuilder,
      public tracking: TrackingService,
      private patientService: PatientService,
      private alertService: AlertService,
  ) {
    this.subjectsList = [];
  }

  ngOnInit() {
    this.infoSupport();
    this.alertService.clear();
    this.patientId = parseInt(JSON.parse(localStorage.getItem('patientId')));
    this.getSubjects();
  }
  expandables(e) {
      e.stopPropagation();
      e.preventDefault();

      if (!this.animCurrentlyPlaying) {
          const $content = e.target.parentElement.children[2];
          this.animCurrentlyPlaying = true;

          if ($content.classList.contains('close')) {
              this.renderer.setStyle($content, 'height', $content.children[0].clientHeight + 'px');
              this.renderer.removeClass($content, 'close');
              this.renderer.addClass($content, 'open');
          } else {
              this.renderer.setStyle($content, 'height', '0');
              this.renderer.removeClass($content, 'open');
              this.renderer.addClass($content, 'close');
          }

          this.animCurrentlyPlaying = false;
      }
  }
  loadMentionsLegales() {
      //console.log('*** load Mentions légales ***');
      const dialogRef = this.dialog.open(ViewTextesLegauxComponent,
          {
              disableClose: false,
              data: {
                  typeTexte: 'ml'
              }
          }
      );
  }

    private infoSupport() {
        this.supportForm = this.formBuilder.group({
            supportText: ['', [Validators.required]],
            supportSubject: ['', [Validators.required]],
        });
    }

   getSubjects() {
     this.patientService.getSupportSubjects().pipe(first())
      .subscribe(
        data => {
          this.subjectsList = data;
        },
        error => {
        });
   }

  onFormSubmit(form) {
      this.submitLoading = true;
      this.submitted = true;
      if (this.supportForm.invalid) {
          return;
      }
    const supportFormContent: Support = {
      question:  form.controls.supportText.value,
      supportSujetKey: form.controls.supportSubject.value,
    };

    this.patientService.supportRequest(this.patientId, supportFormContent)
      .pipe(first())
      .subscribe(
        data => {
          form.reset();
          this.alertMessageSendedShowed = true;
          this.submitLoading = false;
        },
        error => {
          this.alertService.error(error);
          this.submitLoading = false;
        });

  }

}
